<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { instance } from '@/dashboard/api/instance';

const route = useRoute();
const short_link = computed(() => route.params?.short_link);

const draft_image = ref(null);

onMounted(async () => {
  const link = short_link.value;
  const response = await instance.get('/app/links/get_link_data', { params: { short_link: link } });
  if (response.data.data.type === 'draft') {
    draft_image.value = response.data.data;
  }
});
</script>

<template>
  <div>Title</div>
</template>

<style scoped lang="scss"></style>
